<template>
    <div class="d-flex justify-center align-center position-relative">
        <!-- <img :src="starImg" alt="stars" class="position-absolute" v-if="showStars"/> -->
        <!-- <div class="star-text text-center mt-5"> -->
        <div class="btn-outline">
            <span class="text-h6">{{ content }}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        content: { type: [String, Number], default: '' },
    },
    data() {
        return {
            // eslint-disable-next-line global-require
            starImg: require('@/assets/img/gamifications/estrellas-calificacion.svg'),
        }
    },
    computed: {
        showStars() {
            if (this.content === 0) return false
            else if (this.content === '0') return false
            return true
        },
    }
}
</script>
<style>
.star-text {
    color: #ff9c00;
    font-family: 'Patua One';
    letter-spacing: 0;
    line-height: 98px;
    text-align: center;
}
.btn-outline{
    background: #FFFFFF1A;
    border: 1px solid white;
    border-radius: 10px;
    padding: .4em .8em;
}
</style>
